var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-task-detail',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"pt-integral-task-detail__withData",attrs:{"data":_vm.currentData}})}
var staticRenderFns = []

export { render, staticRenderFns }